import React from "react";
import QNuovaScheda from "../../libQuestionario/pages/QNuovaScheda";
import PDTAHeader from "./components/PDTAHeader";
import { API_SERVICES } from "..";

const PDTAScheda = () => {
  return <QNuovaScheda
    homeRoute={API_SERVICES.PDTA.HOME_ROUTE}
    root={API_SERVICES.PDTA.ROOT}
    headerComponent={<PDTAHeader label="Questionario" />} />
}

export default PDTAScheda